<template>
  <FormItem :prop="name" :label="label">
    <DatePicker v-bind="$attrs" v-on="$listeners" />
  </FormItem>
</template>

<script>
import { DatePicker, FormModel } from "ant-design-vue";

export default {
  components: {
    DatePicker,
    FormItem: FormModel.Item
  },
  props: {
    name: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: ""
    }
  }
};
</script>

<style></style>
